export class GetSourceAccountResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sourceAccount",
            "baseName": "sourceAccount",
            "type": "SourceAccount",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetSourceAccountResponse.attributeTypeMap;
    }
    constructor() {
    }
}
